<div class="products">
    <div class="products-icon-circle {{ getBackgroundColor() }}">
        <img class="card-icon-img" [src]="iconForCard(data)" alt="">
    </div>

    <div class="products-info">
        <p class="products-info-name">{{ data?.product }}</p>
        <p class="products-info-meta">
            <span class="label">Nº de póliza / contrato </span>
            <strong>{{ data?.number }}</strong>
            <strong class="collective" *ngIf="undefined !== data?.collective"> (Colectivo {{ data?.collective }})</strong>
        </p>
        <p class="products-info-meta">
            <span class="label">Vigencia </span>
            <strong>{{ data?.startDate | date: "dd/MM/yyyy" }} - {{ data?.endDate | date: "dd/MM/yyyy" }}</strong>
        </p>
    </div>

    <div class="products-status">
        <span class="status-badge" [ngClass]="data.suspended ? 'status-badge--suspended' : 'status-badge--active'">
            {{ data.status }}
        </span>
        <p class="products-tomador" *ngIf="undefined !== data?.taker && data.isTaker === true">
            <span class="label">Tomador </span><strong>{{data?.taker.name}} {{data?.taker.surname}} {{data?.taker.lastname}}</strong>
        </p>
        <p class="products-tomador" *ngIf="undefined !== data?.riskDescription">
            <span class="label">Riesgo </span><strong>{{data?.riskDescription}}</strong>
        </p>
    </div>

    <div class="products-button">
        <app-actions-dropdown [items]="actions"></app-actions-dropdown>
    </div>
</div>
